<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">{{ "GENERAL" | translate }}</h6>
      @if(authService.isAuthorized([PermissionsEnum.Remotecommands_connectdisconnect_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('remote-command/connect-disconnect')"
          [ngClass]="{ selected: isActive('remote-command/connect-disconnect') }"
        >
          <span>{{ "REMOTECOMMAND-CONNECTDISCONNECT" | translate }}</span>
        </div>
      }
      @if(
        authService.isAuthorized([PermissionsEnum.Remotecommands_tokenload_view]) ||
        authService.isAuthorized([PermissionsEnum.Remotecommands_clearcredit_view]) ||
        authService.isAuthorized([PermissionsEnum.Remotecommands_cleartamper_view])
      ){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('remote-command/token-load')"
          [ngClass]="{ selected: isActive('remote-command/token-load') }"
        >
          <span>{{ "REMOTECOMMAND_TOKENLOAD" | translate }}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Remotecommands_sequentialtokenload_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('remote-command/sequential-token-load')"
          [ngClass]="{ selected: isActive('remote-command/sequential-token-load') }"
        >
          <span>{{ "SEQUENTIALTOKENLOAD_TITLE" | translate }}</span>
        </div>
      }
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
